/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MemberRoleDto } from './memberRoleDto.schema';

export const IReadOnlyListOfMemberRoleDto = zod.array(zod.lazy(() => MemberRoleDto));

export type IReadOnlyListOfMemberRoleDto = zod.input<typeof IReadOnlyListOfMemberRoleDto>;
export type IReadOnlyListOfMemberRoleDtoOutput = zod.output<typeof IReadOnlyListOfMemberRoleDto>;
